export default __webpack_public_path__ + "static/media/banner2.92933e72.jpg";